export enum Operator {
  EQUALS = 'EQUALS',
  UNEQUALS = 'UNEQUALS',
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/enums/operator.enum.ts